// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-outline{height:65px;position:absolute;top:-18px;right:98%;z-index:500;fill:none;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;stroke:url(#linear-gradient)}.tab-outline.show-wallet-prompt{top:auto}", ""]);
// Exports
module.exports = exports;
